export const GET_APP_STAGE = "GET_APP_STAGE";

export const GetAppStage = () => {
    return { type: GET_APP_STAGE };
};
